import { render, staticRenderFns } from "./dateDimensionType.vue?vue&type=template&id=2cbddb38&scoped=true"
import script from "./dateDimensionType.vue?vue&type=script&lang=js"
export * from "./dateDimensionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbddb38",
  null
  
)

export default component.exports